import { render, staticRenderFns } from "./PlmnMainPage.vue?vue&type=template&id=7b6b3a22&scoped=true&"
import script from "./PlmnMainPage.vue?vue&type=script&lang=js&"
export * from "./PlmnMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6b3a22",
  null
  
)

export default component.exports